import { render, staticRenderFns } from "./TheoryStudentMatchModal.vue?vue&type=template&id=da78afa6&scoped=true&"
import script from "./TheoryStudentMatchModal.vue?vue&type=script&lang=ts&"
export * from "./TheoryStudentMatchModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da78afa6",
  null
  
)

export default component.exports